import {Injectable} from '@angular/core';
import {Observable, Subject} from 'rxjs';

@Injectable({providedIn: 'root'})
export class SliderService {
  private subject: Subject<void> = new Subject<void>();

  resetSlider(): void {
    this.subject.next();
  }

  getReset$(): Observable<void> {
    return this.subject.asObservable();
  }
}
